import { render } from "./DataSettings.vue?vue&type=template&id=3a7f0f38&scoped=true"
import script from "./DataSettings.vue?vue&type=script&lang=js"
export * from "./DataSettings.vue?vue&type=script&lang=js"

import "./DataSettings.vue?vue&type=style&index=0&id=3a7f0f38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.108.4_postcss@8.5.18_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7f0f38"]])

export default __exports__